<template>
  <div class="userStatistic">
    <pageTitle />
    <div class="page-main">
      <div class="numTip-wrap">
        <p class="numTip" v-for="el in summaryStatisticsData">
          <span class="numTip-value" v-text="el.value" :style="{ color: el.color }" />
          <span class="numTip-name">
            <span v-text="el.name" />
            <span v-text="el.tip" />
          </span>
        </p>
      </div>
      <div class="tip_can">
        <mLine class="h300" :option="Option" />
      </div>
    </div>
    <a-row :gutter="20">
      <a-col class="page-bg" :span="12">
        <div class="page-main">
          <div class="userStatistic-header">
            <span
              class="userStatistic-header-title"
              v-text="`近${codeNumber[PeopleIndex]}个月使用总人数`"
            />
            <a-radio-group default-value="1" button-style="solid" @change="change">
              <a-radio-button value="1">一个月</a-radio-button>
              <a-radio-button value="3">三个月</a-radio-button>
              <a-radio-button value="6">六个月</a-radio-button>
            </a-radio-group>
          </div>
          <mChartDom class="h300" :option="PeopleBar" />
        </div>
      </a-col>
      <a-col class="page-bg" :span="12">
        <div class="page-main">
          <div class="userStatistic-header">
            <span
              class="userStatistic-header-title"
              v-text="`近${codeNumber[RatioIndex]}个月使用占比`"
            />
            <a-radio-group default-value="1" button-style="solid" @change="RatioChange">
              <a-radio-button value="1">一个月</a-radio-button>
              <a-radio-button value="3">三个月</a-radio-button>
              <a-radio-button value="6">六个月</a-radio-button>
            </a-radio-group>
          </div>
          <mChartDom class="h300" :option="ratioBar" />
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import pageTitle from "@/components/business/pageTitle";
import mPie from "@/components/business/echartsComponents/mPie";
import mLine from "@/components/business/echartsComponents/mLine";
import mChartDom from "@/components/business/echartsComponents/mChartDom";
// '#0082FF','#FF5B5B','#FFBA36'
const config = {
  lightCalculatorUsedTimes: {
    value: "",
    color: "#0082FF",
    color2: "#C1D6FF",
    name: "光参计算器",
    key: "lightCalculatorUsedTimes",
  },
  colorTemperatureIlluminometerUsedTimes: {
    value: "",
    color: "#FF5B5B",
    color2: "#FFB3B3",
    name: "专业手动光效",
    key: "manualLightEffectUsedTimes",
  },
  manualLightEffectUsedTimes: {
    value: "",
    color: "#FFBA36",
    color2: "#FFEBC6",
    name: "数字色温照度",
    key: "colorTemperatureIlluminometerUsedTimes",
  },
};
export default {
  name: "auxiliaryMeans",
  components: {
    pageTitle,
    mPie,
    mLine,
    mChartDom,
  },
  data() {
    return {
      pie: [],
      pie1: [],
      allData: {},
      Option: {
        symbol: "none",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          top: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
          axisLabel: {
            color: "#999",
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#999",
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            data: [],
          },
        ],
      },
      barOption: {
        xAxis: {
          type: "category",
          data: [],
        },
        yAxis: {
          type: "value",
          min: 1,
        },
        series: [
          {
            data: [],
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
          },
        ],
      },
      PeopleBar: {}, // 人数
      ratioBar: {}, // 比例
      PeopleIndex: 1,
      RatioIndex: 1,
      codeNumber: ["零", "一", "二", "三", "四", "五", "六"],

      dataUrl: "/bluetoothlight/web/statistics/tool",
      summaryStatisticsData: [],
      summaryStatisticsMap: {
        lightCalculatorUsedTimes: "光参计算器",
        colorTemperatureIlluminometerUsedTimes: "数字色温照度",
        manualLightEffectUsedTimes: "专业手动光效",
      },
      total: 0,
    };
  },
  created() {
    this.getData();
    this.NumberOfPeople(1);
    this.setRatioBar(1);
  },
  methods: {
    period: async function (multiple = 1) {
      const res = await this.$get("bluetoothlight/web/statistics/tool/period", {
        endDate: moment().format(this.$root.$data.dateFormat),
        startDate: moment(new Date().getTime() - 60 * 60 * 24 * 1000 * (30 * multiple || 1)).format(
          this.$root.$data.dateFormat
        ),
      });
      return res?.resultData;
    },
    getData: async function () {
      const res = await this.$get(this.dataUrl, {
        // startDate: moment().format(this.$root.$data.dateFormat),
        // endDate: moment(new Date().getTime() - 60*60*24*30*1000).format(this.$root.$data.dateFormat)
      });

      const resultStatus = res?.resultStatus;
      if (!resultStatus) return false;
      const data = res?.resultData;
      this.allData = data;
      console.log(data);

      this.periodStatistics(data?.periodStatistics);
      this.summaryStatistics(data?.summaryStatistics);
    },
    verifyData(data) {
      return data && data.length;
    },
    rowClassName(record, index) {
      let className = "";
      if (index % 2 === 1) className = "tableBg";
      return className;
    },

    periodStatistics(data) {
      if (!this.verifyData(data)) return false;
      const { xAxis, series } = this.Option;
      const lineOps = series?.[0] || {
        type: "line",
        emphasis: {
          focus: "series",
        },
      };

      this.Option = {
        ...this.Option,
        title: {
          text: "近三十天用户使用频次(一个用户每天算一次)",
          left: "left",
          bottom: "bottom",
          textStyle: {
            fontSize: 14,
            color: "#a6a6a6",
          },
        },
        series: Object.keys(config).map((el) => {
          const item = config[el];
          const { color, color2, key } = item;
          return {
            ...lineOps,
            ...item,
            smooth: true,
            emphasis: {
              focus: "series",
            },
            symbol: "none",
            areaStyle: this.getAreaStyle(color, color2),
            data: data.map((el) => el[key]) || [],
          };
        }),
        xAxis: {
          ...xAxis,
          data: data.map((el) => el.totalDate),
        },
      };
    },
    summaryStatistics(data) {
      if (!data) return false;
      let arr = Object.keys(data);

      if (!arr || !arr.length) return false;

      this.total = Object.values(data).reduce((acc, cur) => (acc += cur), 0);
      const { summaryStatisticsMap } = this;
      arr.forEach((key) => {
        const name = summaryStatisticsMap?.[key];
        if (!name) return false;
        const value = data?.[key] || 0;
        this.summaryStatisticsData.push(
          ...[
            { name, tip: "使用总次数", value, color: config[key]?.color },
            {
              name,
              tip: "使用占比",
              value: this.percentage(value, this.total),
              color: config?.[key]?.color,
            },
          ]
        );
      });
      return data;
    },
    percentage(value, total) {
      if (!value || !this.total) return "0.00%";
      return `${((value / total) * 100)?.toFixed(2)}%` || "0%";
    },
    NumberOfPeople: async function (multiple) {
      const data = await this.period(multiple);
      if (!data) return false;
      this.PeopleBar = JSON.parse(JSON.stringify(this.barOption));
      Object.keys(data).forEach((el) => {
        const item = config[el];
        this.PeopleBar.series[0].data.push({
          ...(item || {}),
          value: data[el],
          itemStyle: this.getItemStyle(item),
        });
      });
      this.PeopleBar.xAxis.data = Object.keys(data).map((el) => this.summaryStatisticsMap[el]);
    },
    change(e) {
      const value = Number(e?.target?.value || 1);
      this.PeopleIndex = value;
      this.NumberOfPeople(value);
    },
    setRatioBar: async function (multiple) {
      const data = await this.period(multiple);
      if (!data) return false;
      this.ratioBar = JSON.parse(JSON.stringify(this.barOption));
      const total = Object.values(data).reduce((acc, cur) => (acc += cur), 0);
      Object.keys(data).forEach((el) => {
        const item = config[el];

        this.ratioBar.series[0].data.push({
          ...(item || {}),
          value: this.percentage(data[el], total).replace("%", ""),
          itemStyle: this.getItemStyle(item),
        });
      });
      this.ratioBar.xAxis.data = Object.keys(data).map((el) => this.summaryStatisticsMap[el]);
      this.ratioBar.tooltip = {
        trigger: "item",
        formatter: "{b}<br/>{c}%",
      };
    },

    RatioChange(e) {
      const value = Number(e?.target?.value || 1);
      this.RatioIndex = value;
      this.setRatioBar(value);
    },
    getAreaStyle(color, color2) {
      return {
        opacity: 0.1,
        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 0.9, [
          {
            offset: 0,
            color: color,
          },
          {
            offset: 1,
            color: color2,
          },
        ]),
      };
    },
    getItemStyle(item) {
      return {
        normal: {
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: item.color },
            { offset: 1, color: item.color2 },
          ]),
        },
      };
    },
  },
  computed: {
    _totalAccountNum() {
      return this?.allData?.summaryStatistics?.totalAccountNum || 0;
    },
    _curMonthAddedAccount() {
      return this?.allData?.summaryStatistics?.curMonthAddedAccount || 0;
    },
  },
};
</script>

<style lang="less">
.tableBg {
  background-color: rgba(0, 0, 0, 0.06);
}

.userStatistic-header {
  display: flex;
  justify-content: space-between;

  .userStatistic-header-title {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    color: #333333;
    line-height: 22px;
  }
}

.h300 {
  height: 300px !important;
}
.tip_can {
  margin-top: 60px;
  @media screen and (max-width: 1355px) {
    overflow-x: scroll;
  }

  > #mChartDom {
    min-width: 1355px;
  }
}

//.gutter-row {
//  margin-top: 20px;
//}
</style>
